
import React from 'react';
import { Language } from '../../types';

interface RobotDeleteModalProps {
  language: Language;
  onCancel: () => void;
  onConfirm: () => void;
  isRtl: boolean;
}

const RobotDeleteModal: React.FC<RobotDeleteModalProps> = ({ language, onCancel, onConfirm, isRtl }) => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={onCancel}></div>
      <div className="relative bg-white dark:bg-[#111115] w-full max-w-sm rounded-[32px] shadow-2xl p-6 border border-white/10 animate-in zoom-in-95">
         <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-rose-500/10 flex items-center justify-center text-rose-500 text-2xl mb-4"><i className="fas fa-trash"></i></div>
            <h3 className="text-lg font-black text-slate-800 dark:text-white mb-2">{isRtl ? 'حذف الوكيل؟' : 'Delete Agent?'}</h3>
            <div className="flex w-full gap-3 mt-4">
               <button onClick={onCancel} className="flex-1 py-3 bg-slate-100 dark:bg-white/5 rounded-xl text-xs font-black text-slate-500 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-white/10 transition-colors">{isRtl ? 'إلغاء' : 'Cancel'}</button>
               <button onClick={onConfirm} className="flex-1 py-3 bg-rose-500 hover:bg-rose-600 rounded-xl text-xs font-black text-white shadow-lg shadow-rose-500/20 transition-all">{isRtl ? 'حذف' : 'Delete'}</button>
            </div>
         </div>
      </div>
    </div>
  );
};
export default RobotDeleteModal;
